import type {
  GetDomainsManagementPlatformServiceOriginsData,
  GetDomainsManagementPlatformServiceOriginsResponse,

  GetDomainsManagementPlatformServiceOriginsByIdData,
  GetDomainsManagementPlatformServiceOriginsByIdResponse
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getServiceOriginsApiModule(affiliatesApi: AxiosInstance) {
  return {
    // /**
    //  * Get service origins count
    //  *
    //  * @param {Object} params
    //  * @param {String} params.search
    //  *
    //  * @return {Promise<Object>} api response
    //  */
    // getServiceOriginsCount(params) {
    //   return affiliatesApi.get('/domains-management/platform-service-origins/count', { params });
    // },

    /**
     * Get service origins
     *
     * @param {Object} params
     * @param {String} params.sort_column
     * @param {String} params.sort_dir
     * @param {String} params.search
     * @param {Number} params.limit
     * @param {Number} params.offset
     *
     * @return {Promise<Object>} api response
     */
    getServiceOrigins(params: GetDomainsManagementPlatformServiceOriginsData['query']) {
      return affiliatesApi.get<GetDomainsManagementPlatformServiceOriginsResponse>(
        '/domains-management/platform-service-origins',
        { params }
      );
    },

    /**
     * Get service origin by id
     *
     * @param {String} id
     *
     * @return {Promise<Object>} api response
     */
    getServiceOriginById(id: string) {
      return affiliatesApi.get<GetDomainsManagementPlatformServiceOriginsByIdResponse>(
        `/domains-management/platform-service-origins/${id}`
      );
    },
  }
}

